import { fromEvent } from 'rxjs'

/**
 * Observable that emits when the user tries to leave the page.
 * Doesn't emit in Firefox unless preventDefault is called.
 * Also doesn't emit if browser is force closed.
 */
export const beforeUnloadSubject = fromEvent(window, 'beforeunload', {
	passive: true,
	capture: true,
})
